import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { LoginService } from "../services/login.service";

@Injectable()
export class AuthExpiredInterceptor implements HttpInterceptor {

    constructor(private service: LoginService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap({
                error: (err: HttpErrorResponse) => {
                    if (err.status === 401 && this.service.isAuthenticated()) {
                        this.service.logout();
                    }
                }
            })
        );
    }

}